import React, { useState } from 'react';
import { SportTag } from "./SportTag";
import { VenueCard } from "./VenueCard";
import { BookingModal } from "./BookingModal";
import styles from "./Facilities.module.css";
import F_1 from "../images/F-1.jpg";
import F_2 from "../images/F-2.jpg";
import F_3 from "../images/F-3.jpg";
import F_4 from "../images/F2.jpeg";
import F_5 from "../images/F5.jpeg";

const initialVenues = [
  {
    id: 1,
    name: "Volley Central",
    price: "10",
    imageUrl: F_1,
    sports: ["Volleyball"],
  },
  {
    id: 2,
    name: "Cricket Turf",
    price: "10",
    imageUrl: F_4,
    sports: ["Cricket"],
  },
  {
    id: 3,
    name: "BasketBall Court",
    price: "20",
    imageUrl: F_3,
    sports: ["Basketball"],
  },
  {
    id: 4,
    name: "Tennis Court",
    price: "15",
    imageUrl: F_5,
    sports: ["Tennis"],
  },
];

const sports = ["All", "Volleyball", "Cricket", "Hockey", "Tennis", "Basketball"];
const timeSlots = ["10:00 AM", "10:30 AM", "11:00 AM", "11:30 AM", "12:00 PM"];

export const FacilitiesLayout = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedSport, setSelectedSport] = useState("All");
  const [selectedTimeSlots, setSelectedTimeSlots] = useState({});
  const [showFilters, setShowFilters] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [modalData, setModalData] = useState({
    isOpen: false,
    venue: null,
    selectedTime: null
  });

  // Filter venues based on search query and selected sport
  const filteredVenues = initialVenues.filter(venue => {
    const matchesSearch = venue.name.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesSport = selectedSport === "All" || venue.sports.includes(selectedSport);
    return matchesSearch && matchesSport;
  });

  const handleTimeSlotSelect = (venue, timeSlot) => {
    setSelectedTimeSlots(prev => ({
      ...prev,
      [venue.id]: timeSlot
    }));
    setModalData({
      isOpen: true,
      venue,
      selectedTime: timeSlot
    });
  };

  const handleDateChange = (event) => {
    setSelectedDate(new Date(event.target.value));
  };

  const closeModal = () => {
    setModalData({
      isOpen: false,
      venue: null,
      selectedTime: null
    });
  };

  return (
    <main className={styles.facilities}>
      <div className={styles.searchContainer}>
        <div className={styles.searchBar}>
          <div className={styles.searchInputWrapper}>
            <img
              src="https://cdn.builder.io/api/v1/image/assets/TEMP/08978e937db1f373693796907e8ef51a6bb47d96a0edb1c297bdddcb3682421d"
              alt="Search icon"
              className={styles.icon}
            />
            <input 
              placeholder="Search"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
          <img
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/f1d65db84e78f223849f2aa378ff6ecc47f670c0bba2629f7c57bfceee789fe4"
            alt="Filter icon"
            className={styles.filterIcon}
            onClick={() => setShowFilters(!showFilters)}
            style={{ cursor: 'pointer' }}
          />
        </div>

        <section className={styles.filterSection}>
          <nav className={styles.locationNav}>
            <img
              src="https://cdn.builder.io/api/v1/image/assets/TEMP/7ea445b3fb70732f780edca26d37d8acdd146e9761b0c92fc9bcf170eabd0962"
              alt="Location icon"
              className={styles.locationIcon}
            />
            <span>Jacksonville, USA</span>
          </nav>

          <input 
            type="datetime-local" 
            className={styles.dateTime}
            value={selectedDate.toISOString().slice(0, 16)}
            onChange={handleDateChange}
          />

          <div className={styles.sportsList}>
            {sports.map((sport, index) => (
              <SportTag 
                key={index} 
                name={sport} 
                isActive={sport === selectedSport}
                onClick={() => setSelectedSport(sport)}
              />
            ))}
          </div>
        </section>

        <section className={styles.venueContainer}>
          {filteredVenues.map((venue) => (
            <VenueCard 
              key={venue.id}
              venue={venue} 
              timeSlots={timeSlots}
              selectedTimeSlot={selectedTimeSlots[venue.id]}
              onTimeSlotSelect={(time) => handleTimeSlotSelect(venue, time)}
            />
          ))}
          {filteredVenues.length === 0 && (
            <p>No venues found matching your criteria</p>
          )}
        </section>
      </div>

      <BookingModal 
        isOpen={modalData.isOpen}
        onClose={closeModal}
        venue={modalData.venue}
        selectedTime={modalData.selectedTime}
        selectedDate={selectedDate}
      />
    </main>
  );
};

export default FacilitiesLayout;